import axios from "axios";
import { isSandbox as isSandboxFromState } from "../components/shared/util";

export function getOSSBaseURL(isSandbox?: boolean): string {
  const calculatedIsSandbox = isSandbox != null ? isSandbox : isSandboxFromState();
  return calculatedIsSandbox
    ? process.env.REACT_APP_OSS_SANDBOX_API_URL! // eslint-disable-line @typescript-eslint/no-non-null-assertion
    : process.env.REACT_APP_OSS_API_URL!; // eslint-disable-line @typescript-eslint/no-non-null-assertion
}

export const apiOSS = axios.create({ baseURL: getOSSBaseURL() });

export function updateBaseURL(isSandbox: boolean) {
  apiOSS.defaults.baseURL = getOSSBaseURL(isSandbox);
}

export async function buildAuthHeaders(apiKey: string) {
  return { headers: { "x-api-key": apiKey } };
}

export default apiOSS;
